import React from "react";
import './styles.css'

interface RecommendationItem {
  topic: string;
  details: string;
  isCompleted: boolean;
}

interface ReccommendationTableProps {
  recommendations: RecommendationItem[];
  onToggle: (index: number) => void;
  progress: number;
}

const ReccommendationTable = ({ recommendations, onToggle, progress }: ReccommendationTableProps) => {
  const formatRecommendationDetails = (details: string) => {
    const [questionPart, ...recommendationParts] = details.split(':');
    const recommendation = recommendationParts.join(':').trim();

    return (
      <>
        <span className="question-number">{questionPart}:</span>
        <span className="recommendation-text">{recommendation}</span>
      </>
    );
  };

  return (
    <div className="topic-breakdown">
      <div className="recommendations-header">
        <h2 className="topic-breakdown__title">Exam Recommendations</h2>
        <div className="progress-container">
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>
        {progress > 0 && (
          <p className="motivation-text">
            {progress === 100 
              ? "🎉 Amazing! You've completed all recommendations!"
              : `🎯 Great progress! Keep going!`}
          </p>
        )}
      </div>
      <div className="recommendations-table-wrapper">
        <table className="recommendations-table">
          <tbody>
            {recommendations.map((rec, index) => (
              <tr 
                key={index} 
                className={`recommendation-row ${rec.isCompleted ? 'completed' : ''}`}
              >
                <td className="checkbox-cell">
                  <label className="checkbox-container">
                    <input
                      type="checkbox"
                      checked={rec.isCompleted}
                      onChange={() => onToggle(index)}
                    />
                    <span className="checkmark"></span>
                  </label>
                </td>
                <td className="topic-cell">
                  <h3 className="recommendation-topic">{rec.topic}</h3>
                  <div className="mobile-details">
                    {rec.details.split('. ').map((detail, i) => (
                      <p key={i} className="recommendation-point">
                        {formatRecommendationDetails(detail)}
                      </p>
                    ))}
                  </div>
                </td>
                <td className="details-cell desktop-only">
                  {rec.details.split('. ').map((detail, i) => (
                    <p key={i} className="recommendation-point">
                      {formatRecommendationDetails(detail)}
                    </p>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReccommendationTable;